import { withParentSize } from '@visx/responsive';
import RubricOrgTree from './RubricOrgTree';

/** Same pattern as OrgTree/index.js: inject measured width for the cluster layout. */
const RubricOrgTreeWithSize = ({ parentWidth, ...props }) => (
  <RubricOrgTree parentWidth={parentWidth} {...props} />
);

export default withParentSize(RubricOrgTreeWithSize);
